import LayoutTemplate from './LayoutTemplate';

export default LayoutTemplate;
